import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';
import * as Icon from '@material-ui/icons';
import { defaultStyles } from '../../../../utils/Theme';

const QButton = ({
    qViz,
    qAppPromise,
    qDocPromise,
    type,
    title,
    color,
    rounded,
    disabled,
    block,
    size,
    options,
}) => {
    const classes = defaultStyles();
    // eslint-disable-next-line no-unused-vars
    let qApp = null;
    // eslint-disable-next-line no-unused-vars
    let qDoc = null;

    // Sept 2018 BUG. Adds the current www folder in the path
    const urlFix = (url) => url.split(/(?=http.?:\/\/)(.*)(?=http.?:\/\/)/)[2];

    const action = async () => {
        switch (type) {
            default:
            case 'exportData':
                if (qViz) {
                    const _options = options || { format: 'CSV_T', state: 'P' };
                    const url = await qViz.exportData(_options);
                    // const _url = url.split(/(?=http.?:\/\/)(.*)(?=http.?:\/\/)/)[2];
                    window.open(url, '_blank');
                }
                break;
            case 'exportImg':
                if (qViz) {
                    const _options = options || {
                        width: 300,
                        height: 400,
                        format: 'JPG',
                    };
                    const url = await qViz.exportImg(_options);
                    const _url = urlFix(url);
                    window.open(_url, '_blank');
                }
                break;
            case 'exportPdf':
                if (qViz) {
                    const _options = options || {
                        documentSize: 'a4',
                        orientation: 'landscape',
                        aspectRatio: 2,
                    };
                    const url = await qViz.exportPdf(_options);
                    const _url = urlFix(url);
                    window.open(_url, '_blank');
                }
                break;
        }
    };

    useEffect(() => {
        (async () => {
            // eslint-disable-next-line
      if (qDocPromise) qDoc = await qDocPromise
            // eslint-disable-next-line
      if (qAppPromise) qApp = await qAppPromise
        })();
        // eslint-disable-next-line
  }, [qDocPromise, qAppPromise, qViz])

    return (
        <Tooltip title={title}>
            <IconButton
                // className={classes.buttonPrimary}
                color={color}
                // circular={rounded}
                size={size}
                //fullWidth={block}
                disabled={disabled}
                onClick={action}
            >
                <Icon.GetApp />
            </IconButton>
        </Tooltip>
    );
};
QButton.propTypes = {
    qViz: PropTypes.object,
    qAppPromise: PropTypes.func,
    qDocPromise: PropTypes.func,
    type: PropTypes.string,
    title: PropTypes.string,
    options: PropTypes.object,
    children: PropTypes.node,
    color: PropTypes.oneOf([
        'default',
        'primary',
        'secondary',
        'warning',
        'error',
        'info',
    ]),
    rounded: PropTypes.bool,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    block: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    onClick: PropTypes.func,
};
QButton.defaultProps = {
    children: null,
    color: 'primary',
    rounded: null,
    active: null,
    disabled: null,
    block: null,
    size: 'small',
    onClick: null,
};

export default QButton;
